import profile from './profile';
import recovery_password from './recovery-password';
import documentValidation from './document-validation';

export default {
  ...profile,
  ...recovery_password,
  ...documentValidation,
};
